// extracted by mini-css-extract-plugin
export var activeDot = "_7x-c";
export var buttonContainer = "_7x-9";
export var channelButton = "_7x-a";
export var clickable = "_7x-d";
export var content = "_7x-0";
export var contentFull = "_7x-2";
export var contentThird = "_7x-1";
export var contentWrapper = "_7x-7";
export var description = "_7x-5";
export var heightShort = "_7x-f";
export var image = "_7x-3";
export var imageContainer = "_7x-4";
export var selectButton = "_7x-e";
export var spinnerContainer = "_7x-b";
export var titleContent = "_7x-8";
export var titleWrapper = "_7x-6";